module.exports = __webpack_public_path__ + "img/right-arrow-payment.819e90f0.svg";